import { useCallback } from "react"

export const useRedirectToLogin = () => {

    return useCallback(() => {
        window.location.href = process.env.REACT_APP_LOGIN_URL as string
    }, [])
}
